export const capitalize = (str: string) =>
  str.split(' ').reduce((acc, word) => {
    acc += word.charAt(0).toUpperCase() + word.slice(1);
    return acc;
  }, '');
